import { FC, ReactElement, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, User } from 'firebase/auth';

import { Loader } from '@mopla/ui';

const PrivateRoute: FC<{ children: ReactElement }> = ({ children }) => {
	const navigate = useNavigate();
	const [userData, setUserData] = useState<User | null>(null);
	const [loading, setLoading] = useState<boolean>(true);

	useEffect(() => {
		setLoading(true);
		getAuth().onAuthStateChanged((user) => {
			setUserData(user);
			setLoading(false);
		});
	}, []);

	useEffect(() => {
		if (!loading && !userData) {
			navigate('/login');
		}
	}, [loading, userData, navigate]);

	if (loading) {
		return <Loader delay={100} />;
	}

	return !loading && userData && userData.emailVerified ? children : null;
};

export default PrivateRoute;
